import { Controller } from "@hotwired/stimulus"

// Removes the element and remembers the dismissal in a year-long cookie,
// so server-side rendering can skip it on subsequent requests.
export default class extends Controller {
  static values = { cookie: String }

  dismiss() {
    document.cookie = `${this.cookieValue}=1;path=/;max-age=31536000;samesite=lax`
    this.element.remove()
  }
}
